import React from 'react';
import generateHreflang from 'lib/utils/generateHreflang';
import PATHS from 'lib/navigation/paths';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { mapNamedLocaleToLocale } from 'lib/data/localesMap';
import { defaultNS } from 'next-i18next.config';
import { FaqsViewV2 } from 'views/rebranded-module/information-module/FaqsViewV2';
import { HydrationWrapper } from 'views/common/components';
import { API } from 'lib/config/axios';
import isCrawlers from 'lib/utils/isCrawlers';
import { serverFetch } from 'lib/utils/serverFetch';
import { getOriginalSegment } from 'lib/utils/getOriginalSegment';
import { FAQS_TYPES_PATHS } from 'lib/utils/CONSTANTS';
import { ContentContext } from 'views/rebranded-module/common/context/useContent';
import { useFAQSCMSData } from 'views/rebranded-module/information-module/FaqsViewV2/hooks/useFAQSCMSData';

const FaqsEntry = (props) => {
  const { serverData, ssrRender, originalKey } = props;
  const content = useFAQSCMSData();
  return (
    <HydrationWrapper>
      <ContentContext.Provider value={content?.data}>
        <FaqsViewV2
          serverData={serverData}
          ssrRender={ssrRender}
          originalKey={originalKey}
        />
      </ContentContext.Provider>
    </HydrationWrapper>
  );
};

export async function getServerSideProps(ctx) {
  const {
    locale, query, req, res, pathname,
  } = ctx;
  const ssrRender = isCrawlers(req.headers['user-agent']);

  let serverData = null;
  let layoutData = null;
  let serverError = null;

  if (ssrRender && pathname != '/_error') {
    const [layoutRes, faqsPageData] = await Promise.all([
      serverFetch(ctx, API.layout),
      serverFetch(ctx, API.faqs, query),
    ]);
    if (layoutRes.success && layoutRes.data) {
      layoutData = layoutRes.data;
    } else {
      res.statusCode = 503;
      throw new Error('Rendering halted because we failed to load layout data');
    }
    if (faqsPageData.success && faqsPageData.data) {
      serverData = faqsPageData.data;
    } else {
      serverError = {
        statusCode: faqsPageData?.error?.response?.status,
      };
    }
  }
  const slugSSR = query.slug || null;
  let hreflangData;
  const originalKey = getOriginalSegment(
    slugSSR,
    locale,
    Object.values(FAQS_TYPES_PATHS),
  );
  if (slugSSR) {
    hreflangData = generateHreflang(
      PATHS.faqs.withSlug(originalKey).url,
      locale,
    );
  } else {
    hreflangData = generateHreflang(PATHS.faqs.index().url, locale);
  }
  if (serverError) {
    ctx.res.statusCode = serverError.statusCode;
  }
  return {
    props: {
      ...(await serverSideTranslations(mapNamedLocaleToLocale[locale], [
        ...defaultNS,
        'faqs_page',
        'routes',
      ])),
      hreflangData,
      serverData,
      layoutData,
      ssrRender,
      serverError,
      originalKey,
      rebrandingPage: true,
      options: {
        showAiChat: true,
      },
    },
  };
}
export default FaqsEntry;
